<template>
  <span class="TagItem" :class="acState?'TagItemAc':''" @click="acStateFn( value )">{{ name }}</span>
</template>
<script type="text/javascript">
  export default {
    name: 'xk-tag-item',
    props: ['name', 'value', 'state', 'AcState'],
    data () {
      return {
        acState: false,
        status: this.$props.AcState === false ? this.$props.AcState : true
      }
    },
    methods: {
      acStateFn: function () {
        let that = this
        if (this.status) {
          that.acState = !that.acState
          that.$emit('clickChange', {state: that.acState, val: this.name})
        }
      }
    }
  }
</script>
<style rel="stylesheet/less" lang="less">
  .TagItem {
    display: inline-block;
    height: 2rem;
    line-height: 2rem;
    border-radius: 1rem;
    padding: 0 0.5rem;
    overflow: hidden;
    border: 1px solid #d3d3d4;
    margin: 0.41666rem;
    background: #fff;
    font-size: 0.8333rem;
    color: #333;
    transition: 0.3s all;
  }

  .TagItemAc {
    color: #f06553;
    border-color: #f06553;
  }
</style>



// WEBPACK FOOTER //
// tagitem.vue?094f2c40